<template>
  <b-row>
    <b-col cols="12">
      <hr class="mt-1 mb-2">
      <span class="h6">{{$t("views.agreements.form.agreementsDevices")}}: </span>
    </b-col>
    <b-col>
      <template v-if="data.agreementDevices && data.agreementDevices.length > 0">
        <b-row v-for="(item, index) in data.agreementDevices" :key="index">
          <div class="text-center d-inline-block align-self-center ml-3">
            <button
              type="button"
              class="btn btn-link fa fa-trash fa-lg"
              @click="removeDevice(index)"
              v-b-tooltip :title="$t('buttons.delete')">
            </button>
          </div>
          <b-col md="4">
            <model-select v-model="data.agreementDevices[index].device" :options="devicesOptions" :placeholder="$t('views.agreements.form.select')" required class="mb-1 mt-2" name="item">
            </model-select>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col>
          <b-button class="btn btn-primary" @click="addNewDevice()">{{ $t('views.agreements.form.addNewDevice') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import remove from '@/utils/remove'

export default {
  name: 'AgreementDevices',
  components: {
    ModelSelect
  },

  props: ['data', 'violations'],

  computed: {
    ...mapGetters({
      devicesOptions: 'agreements/list/getDevices'
    })
  },

  created () {
    this.fetchDevices()
  },

  methods: {
    addNewDevice () {
      let item = {}
      this.data.agreementDevices.push(item)
    },
    removeDevice (index) {
      let currentDevice = this.data.agreementDevices[index]
      if (currentDevice['@id']) {
        remove(currentDevice['@id'], () => {
          this.data.agreementDevices.splice(index, 1)
        })
      } else {
        this.data.agreementDevices.splice(index, 1)
      }
    },
    ...mapActions({
      fetchDevices: 'agreements/list/fetchDevices'
    })
  }
}
</script>
